<template>
  <div class="admin-page">
    <h2 class="page-title">时刻管理</h2>
    <div class="admin-toolbar">
      <el-input
        v-model="filters.keyword"
        placeholder="搜索内容"
        clearable
        class="toolbar-input"
        @keyup.enter="onSearch"
      />
      <el-input
        v-model.number="filters.userId"
        placeholder="用户ID"
        clearable
        class="toolbar-input toolbar-input--short"
        @keyup.enter="onSearch"
      />
      <el-select v-model="filters.status" placeholder="状态" clearable class="toolbar-select">
        <el-option label="全部" value="" />
        <el-option label="正常" value="normal" />
        <el-option label="已屏蔽" value="blocked" />
      </el-select>
      <el-button type="primary" @click="onSearch">查询</el-button>
    </div>

    <el-table :data="moments" v-loading="loading" border>
      <el-table-column prop="momentId" label="ID" width="80" />
      <el-table-column prop="userId" label="用户ID" width="90" />
      <el-table-column prop="nickName" label="昵称" width="120" show-overflow-tooltip />
      <el-table-column label="内容" min-width="220">
        <template #default="s">
          <div class="content-cell">{{ s.row.content }}</div>
          <div v-if="s.row.images?.length" class="thumb-row">
            <el-image
              v-for="(img, i) in s.row.images.filter(Boolean).slice(0, 3)"
              :key="i"
              :src="img"
              fit="cover"
              class="thumb"
              :preview-src-list="s.row.images.filter(Boolean)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="likeCount" label="赞" width="60" />
      <el-table-column prop="commentCount" label="评" width="60" />
      <el-table-column label="状态" width="90">
        <template #default="s">
          <el-tag :type="s.row.state === 1 ? 'success' : 'danger'" size="small">
            {{ s.row.state === 1 ? '正常' : '已屏蔽' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="发布时间" width="160">
        <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="s">
          <el-button
            v-if="s.row.state === 1"
            link
            type="warning"
            @click="toggleBlock(s.row, true)"
          >屏蔽</el-button>
          <el-button
            v-else
            link
            type="success"
            @click="toggleBlock(s.row, false)"
          >恢复</el-button>
          <el-button link type="danger" @click="confirmDelete(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <AdminPagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="fetchList"
      @current-change="fetchList"
    />
  </div>
</template>

<script>
import AdminPagination from '@/components/AdminPagination.vue'
import { blockAdminMoment, deleteAdminMoment, fetchAdminMoments } from '@/utils/momentAdmin'

export default {
  name: 'AdminMomentManagement',
  components: { AdminPagination },
  data() {
    return {
      loading: false,
      moments: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filters: {
        keyword: '',
        userId: null,
        status: ''
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(ts * 1000).toLocaleString('zh-CN')
    },
    onSearch() {
      this.currentPage = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const data = await fetchAdminMoments({
          page: this.currentPage,
          pageSize: this.pageSize,
          keyword: this.filters.keyword?.trim() || undefined,
          userId: this.filters.userId || undefined,
          status: this.filters.status || undefined
        })
        this.moments = data.moments || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async toggleBlock(row, block) {
      const action = block ? '屏蔽' : '恢复'
      try {
        await this.$confirm(`确定${action}该时刻？`, '提示', { type: 'warning' })
      } catch {
        return
      }
      try {
        await blockAdminMoment(row.momentId, block)
        this.$message.success(`${action}成功`)
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || `${action}失败`)
      }
    },
    async confirmDelete(row) {
      try {
        await this.$confirm('删除后不可恢复，确定删除？', '警告', { type: 'warning' })
      } catch {
        return
      }
      try {
        await deleteAdminMoment(row.momentId)
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {
        this.$message.error(e.message || '删除失败')
      }
    }
  }
}
</script>

<style scoped>
.page-title {
  margin: 0 0 16px;
}
.admin-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}
.toolbar-input {
  width: 220px;
}
.toolbar-input--short {
  width: 120px;
}
.toolbar-select {
  width: 140px;
}
.content-cell {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4;
}
.thumb-row {
  display: flex;
  gap: 6px;
  margin-top: 6px;
}
.thumb {
  width: 48px;
  height: 48px;
  border-radius: 4px;
}
</style>
